import type { PanelViewerState } from '@/components/chat-v2/lib/panelEntrypoints'

// Latest viewer state per panel tab, written synchronously on every viewer
// callback. The store commit in FileViewer is debounced alongside pdfScrollTop,
// so anything that reads viewer state at an arbitrary moment — building send
// params, a sibling viewer instance mounting — must consult this bridge first
// or a selection/sheet/slide change made just before a send is lost. Entries
// are tagged with the fileId they came from and guarded on read; growth is
// bounded by the session's tab count, so no eviction is needed.
const latestViewerStateByTab = new Map<string, PanelViewerState>()

export const readLatestViewerState = (
  tabId: string,
): PanelViewerState | undefined => latestViewerStateByTab.get(tabId)

export const writeLatestViewerState = (
  tabId: string,
  state: PanelViewerState,
): void => {
  latestViewerStateByTab.set(tabId, state)
}

export const clearLatestViewerState = (tabId: string): void => {
  latestViewerStateByTab.delete(tabId)
}
